import type { RouteRecordRaw } from 'vue-router'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/ws',
  component: Layout,
  name: 'Ws',
  meta: {
    title: 'WS管理',
    icon: 'i-ant-design:cloud-twotone',
  },
  children: [
    {
      path: 'robots',
      name: 'WsRobots',
      component: () => import('@/views/ws/robots/index.vue'),
      meta: {
        title: '机器人列表',
        icon: 'i-ant-design:robot-outlined',
      },
    },
    {
      path: 'statuses',
      name: 'WsRobotStatuses',
      component: () => import('@/views/ws/statuses/index.vue'),
      meta: {
        title: '机器人状态',
        icon: 'i-ant-design:signal-filled',
      },
    },
    {
      path: 'messages',
      name: 'WsMessageRecords',
      component: () => import('@/views/ws/records/messages.vue'),
      meta: {
        title: '消息记录',
        icon: 'i-ant-design:message-outlined',
      },
    },
    {
      path: 'sends',
      name: 'WsSendRecords',
      component: () => import('@/views/ws/records/sends.vue'),
      meta: {
        title: '发送记录',
        icon: 'i-ant-design:send-outlined',
      },
    },
    {
      path: 'features',
      name: 'WsFeatures',
      component: () => import('@/views/ws/features/index.vue'),
      meta: {
        title: '功能清单',
        icon: 'i-ant-design:unordered-list-outlined',
      },
    },
  ],
}

export default routes
